import Strategy from './Strategy'
import Onepage from './onepage'

export default Strategy
export { Onepage }
